import { ApiOpportunity } from "./opportunity.model";

export class ApiDeal extends ApiOpportunity {
}  


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/deal.model.ts